import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Accept either a product id (legacy) or a product object. When a product is passed,
// the cache_v query string forces the browser to bypass stale caches after a cover replace.
export const coverUrl = (productOrId) => {
  if (productOrId && typeof productOrId === "object") {
    const v = productOrId.cache_v || 0;
    return `${API}/products/${productOrId.id}/cover${v ? `?v=${v}` : ""}`;
  }
  return `${API}/products/${productOrId}/cover`;
};

export const previewUrl = (productOrId, page = 0) => {
  if (productOrId && typeof productOrId === "object") {
    const v = productOrId.cache_v || 0;
    return `${API}/products/${productOrId.id}/preview?page=${page}${v ? `&v=${v}` : ""}`;
  }
  return `${API}/products/${productOrId}/preview?page=${page}`;
};
